import React, { useState, useEffect, useContext } from 'react';
import { Form, Input, Button } from 'antd';
import Typing from '../Typing/Typing';
import {validation} from '../../services/validation';
import CmpsAnimation from '../CmpsAnimation/CmpsAnimation';
import Timestamp from '../../components/Timestamp/Timestamp';
import * as Api from '../../services/api';
import { Context } from '../../ChatContext';
import CmpsMsgStatus from '../CmpsMsgStatus/CmpsMsgStatus';
import { ReactComponent as Submit } from '../../assets/images/submit.svg';
import * as Utils from '../../services/utils';

function CmpsFc({onComplete, onScroll, form, onError, onShowInput}) {
  const [typing, setTyping] = useState(true);
  const [waiting, setWaiting] = useState(false);
  const [msg, setMsg] = useState(false);
  const [validInput, setValidInput] = useState(false);
  const [context, setContext] = useContext(Context);
  
  const send = (e) => {
    setMsg(form.getFieldValue("cf"));
    setWaiting(true);

    window.grecaptcha.ready(function() {
      window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_KEY, {action: 'Compass_Chat_CheckByCFAsync'}).then(function(token) {
          Api.checkByCF({
            cf: form.getFieldValue("cf"),
            token: token,
            AvoidC5: false
          }).then(function (response) {
            setWaiting(false)
            let appuntamento = response.data.appuntamento;
            if(appuntamento.oppID) {
              onComplete('step18'); // Utente con appuntamento
            } else {
              if(appuntamento.utente.codice_fiscale) {
                onComplete('step16'); // Utente censito 
                setContext(prevContext => ({
                  ...prevContext,
                  user: appuntamento.utente
                }));          
              } else {
                onComplete('step6'); // Nuovo utente
              }
            }
          })
          .catch(function (error) {
            console.log(error);
            onError();
          });
      });
    });
    
  }

  const myFilial = form.getFieldValue("filiale") ? form.getFieldValue("filiale").nomeFiliale : '---';
  const myTime = form.getFieldValue("ora") ? form.getFieldValue("ora").label : '---';
  const myDate = form.getFieldValue("data") ? form.getFieldValue("data").label : '---';

  const onInputChange = async () => {
    try {
      const values = await form.validateFields(['cf']);
      // Valid
      setValidInput(true);
    } catch (errorInfo) {
      // Not valid
      setValidInput(false);
    }
  };

  useEffect(() => {
    Utils.eventsDataLayer('customPageview', '/chatbot-fissa-appuntamento/codice-fiscale');
    onShowInput(false);
    const timer = setTimeout(() => {
      setTyping(false);
      onShowInput(true);
      onScroll();
    }, 2200);
    return () => clearTimeout(timer);
  }, []);

  return (
      <section id="CF">
        {typing && <Typing wait={1200} />}
        {!typing && (
          <div className="messages messages--receiver">
            <div className="message">
              <CmpsAnimation wait={300}>
                <span className="bubble">Aggiudicato per {myDate}<br /> alle {myTime} nella {myFilial}</span>
              </CmpsAnimation>
              <CmpsAnimation wait={600} last={true}>
                <span className="bubble">Per confermare l’appuntamento,<br /> scrivimi il tuo codice fiscale</span>
                <div className="info">
                  <span className="time"><Timestamp /></span>
                </div>
              </CmpsAnimation>
            </div>
          </div>
        )}
        {msg && (
          <div className="messages messages--sender">
            <CmpsAnimation wait={300}>
              <div className="message">
                <span className="bubble">{msg}</span>
              </div>
              <div className="info">
                <span className="time"><Timestamp /></span>
                <CmpsMsgStatus />
              </div>
            </CmpsAnimation>
          </div>
        )}
        <div className={`cmps_input ${!typing && !msg ? 'show' : ''}`} >
          <Form.Item 
            name="cf"
            rules={[
              { required: true, message: "richiesto" },
              { pattern: validation.cf.rule, message: validation.cf.message },
            ]}
          >
              <Input placeholder="Scrivi qui" autoComplete="off" maxLength={16} onChange={onInputChange} />
          </Form.Item>
          <Button className={['cmps_btn__send']} onClick={send} disabled={!validInput}>
            <Submit className="icon-cmps-submit" />
          </Button>
        </div>
        {waiting && <Typing wait={1200} />}
      </section>
  );
  
} 

export default CmpsFc;